import { generateSkinDefaults } from '@wix/editor-elements-panel';
import type { SkinDefinition } from '@wix/editor-elements-panel/src/adapters/types';

const progressBarSkinParams: SkinDefinition = {
  fntlbl: {
    type: 'FONT',
    defaultValue: 'font_8',
    state: 'regular',
  },
  txtlbl: {
    type: 'TEXT_COLOR',
    defaultValue: 'color_15',
    state: 'regular',
  },
  borderRadius: {
    type: 'BORDER',
    defaultValue: '0px',
    state: 'regular',
  },
  boxShadow: {
    type: 'BOX_SHADOW',
    defaultValue: '0 1px 4px rgba(0, 0, 0, .6)',
    state: 'regular',
  },
  borderSize: {
    type: 'SIZE',
    defaultValue: '0px',
    state: 'regular',
  },
  borderColor: {
    type: 'COLOR',
    defaultValue: 'color_5',
    state: 'regular',
  },
  barBackgroundColor: {
    type: 'COLOR',
    defaultValue: 'color_8',
    state: 'regular',
  },
  barForegroundColor: {
    type: 'COLOR',
    defaultValue: 'color_6',
    state: 'regular',
  },
};

export const progressBarSkinDefinition: Record<string, SkinDefinition> = {
  'wixui.skins.ProgressBar': progressBarSkinParams,
} as const;

export default generateSkinDefaults(progressBarSkinDefinition);
